import EmptyResult from 'components/others/EmptyResult';
import UserIncomeBlock from './UserIncomeBlock';
import type { UserIncomeReportRowType } from '@econtractor/types';

interface ReportUsersDetailProps {
    users: UserIncomeReportRowType[];
}

const ReportUsersDetail = ({ users }: ReportUsersDetailProps) => {
    if (!users.length) return <EmptyResult />;

    return (
        <div>
            {users.map((user) => (
                <UserIncomeBlock key={user.userId} user={user} />
            ))}
        </div>
    );
};

export default ReportUsersDetail;
